import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { MainStore } from "../../../store/main-store";
import { SAlertComponent } from "../../components/s-alert/s-alert.component";
import { UserModel } from "../../models/user-model";
import { GlobalService } from "../../services/global.service";
import { MesaggeText } from "../../texts/mesagge-text";
import { AsociadoModel } from "../../models/datosAsociado";

@Component({
  selector: "right-config",
  templateUrl: "./right-config.component.html",
  styleUrls: ["./right-config.component.scss"]
})
export class RightConfigComponent implements OnInit {
  isConfigToggle: boolean = false;
  userName: string;
  avatarSrc: string;
  objAsociado: AsociadoModel;
  constructor(private _globalService: GlobalService, private route: Router) {
    this.objAsociado = MainStore.db.GetUser();
    let nombre1 = this.objAsociado.nombre1 != undefined ? this.objAsociado.nombre1.trim() : '';
    let nombre2 = this.objAsociado.nombre2 != undefined ? this.objAsociado.nombre2.trim() : '';
    let apellido1 = this.objAsociado.primerApellido != undefined ? this.objAsociado.primerApellido.trim() : '';
    let apellido2 = this.objAsociado.segundoApellido != undefined ? this.objAsociado.segundoApellido.trim() : '';
    this.userName = nombre1 + ' ' + nombre2 + ' ' + apellido1 + ' ' + apellido2;
  }

  ngOnInit() {}

  /**
   * @author Jose Wilson Mulato
   * @description cierra o abre el menu
   */
  configToggle() {
    this.isConfigToggle = !this.isConfigToggle;
  }

  /**
   * @author Jose Wilson Mulato
   * @description el sistema escucha cuando seleciona el boton salir
   */
  OnExitSeccion() {
    SAlertComponent.Confirm2(
      MesaggeText.TEXT_EXIT_APP,
      false,
      MesaggeText.TITLE_ALERT
    ).then(response => {
      if (response) {
       
        window.location.href = MainStore.ORIGIN == 1 ? 
                                      window.location.origin + environment.index + '/#/login' :
                                      '';
      }
    });
  }

  btnExit = {
    Label: "Salir"
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/layouts/right-config/right-config.component.ts